import { useAuthStore } from "@/store/auth";
import { useClientStore } from "@/store/client";

export default defineNuxtPlugin(async ({ $pinia }) => {

  const authStore = useAuthStore($pinia);
  const clientStore = useClientStore($pinia);

  if (authStore.isLogged) {
    try {
      await clientStore.handleServicePrive();
    } catch { }
  }
});
